import { RenderElementProps } from 'slate-react';

import {
  renderEditorElement,
  type CustomSlateNode,
} from '@mint-lib/tw-components';

// Typed lines are 'placeholder' elements, and Shift+Enter (insertSoftBreak)
// splits them into sibling elements. Each line must render as a block carrying
// slate's `attributes`
export const renderElement = (props: RenderElementProps) => {
  const { attributes, children, element } = props;

  switch ((element as CustomSlateNode).type) {
    case 'placeholder':
      return <div {...attributes}>{children}</div>;
    case 'paragraph':
      return <p {...attributes}>{children}</p>;
    default:
      return renderEditorElement(props);
  }
};
